import axios from "axios";
import { FooterData } from "./footerApi.types";

const baseUrl = "/api/footer";
const getFooterUrl = `${baseUrl}/getFooter`;

export const getFooterModel = async (
  currentPageId: number
): Promise<FooterData> => {
  const response = await axios.get<FooterData>(getFooterUrl, {
    params: { currentPageId },
  });

  return response.data;
};
